import { FavoritesGrid } from "../../lib/constants";
import { Col, Row } from "antd";
import { EmptyContent } from "views/components/EmptyContent";
import { ErrorMessage } from "views/components/Message";
import { OfficeList } from "../desktop/components/OfficeList";
import { SkeletonCard } from "./Loaders/SkeletonCard";
import { useCurrentBreakpointName } from "react-socks";
import { useFavorites } from "state/favorites/hooks";
import React from "react";

export const FavoritesContainer = () => {
	const [favorites, loading, error] = useFavorites();
	const currentBp = useCurrentBreakpointName();

	return (
		<>
			<ErrorMessage error={error} />
			{!loading && !favorites.length && (
				<Col span={24}>
					<EmptyContent description="No tienes favoritos aún" />
				</Col>
			)}
			{loading && (
				<Row>
					{[1].concat(favorites).map((_, i) => (
						<Col key={i} {...FavoritesGrid}>
							<SkeletonCard></SkeletonCard>
						</Col>
					))}
				</Row>
			)}
			{!!favorites.length && (
				<OfficeList
					mobile={currentBp === "mobile"}
					offices={favorites}
				></OfficeList>
			)}
		</>
	);
};
